import { whitelineApi } from '@/shared/api';

interface ClientByIdResponse {
  activation_status: string | null;
  address: string | null;
  address_en?: string | null;
  contact_email: string | null;
  contact_phone?: string | null;
  created_at: string;
  default_provider_id?: string | null;
  full_name: string | null;
  full_name_en?: string | null;
  id?: string;
  inn: string | null;
  integration_id?: string | null;
  kpp: string | null;
  ogrn: string | null;
  org_id: string;
  requires_mchd: boolean;
  short_name: string | null;
  updated_at: string;
}

interface GetClientByIdRequest {
  orgId: string;
}

type GetClientByIdResponse = ClientByIdResponse;

export const getClientById = async (
  payload: GetClientByIdRequest
): Promise<GetClientByIdResponse> => {
  const response = await whitelineApi.get<GetClientByIdResponse>(`/api/clients/${payload.orgId}`);

  return response.data;
};

export interface UpdateClientByIdRequest {
  address_en?: string;
  contact_email?: string;
  contact_phone?: string;
  full_name_en?: string;
  orgId: string;
}

export type UpdateClientByIdResponse = ClientByIdResponse;

export const updateClientById = async (
  payload: UpdateClientByIdRequest
): Promise<UpdateClientByIdResponse> => {
  const {
    address_en,
    contact_email,
    contact_phone,
    full_name_en,
    orgId
  } = payload;

  const response = await whitelineApi.patch<UpdateClientByIdResponse>(`/api/clients/${orgId}`, {
    ...(address_en !== undefined ? { address_en } : {}),
    ...(contact_email !== undefined ? { contact_email } : {}),
    ...(contact_phone !== undefined ? { contact_phone } : {}),
    ...(full_name_en !== undefined ? { full_name_en } : {})
  });

  return response.data;
};